import React from 'react';
import StatsPanel from '../components/AdminPanel/StatsPanel';
import ExpiredSessionModal from '../components/Expired/ExpiredSessionModal';
import { useSessionExpiration } from '../hooks/useSessionExpiration';

const AdminPage: React.FC = () => {
    const { isSessionExpired, setIsSessionExpired } = useSessionExpiration();



    return (
        <div className="vx-dashboard-page">
            <ExpiredSessionModal
                isOpen={isSessionExpired}
                onClose={() => {
                    setIsSessionExpired(false);
                    window.location.href = '/login';
                }}
            />
            <div className="vx-dashboard-content">
                <StatsPanel />
            </div>
        </div>
    );
};

export default AdminPage;